// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__19KDm","rootNoMargin":"styles_rootNoMargin__1Rd4p"};